export function GuestJourneyPage() {
  return (
    <div style={{ padding: '2rem', maxWidth: '700px', margin: '0 auto' }}>
      <h1 style={{ color: '#1a6b3c', marginBottom: '1rem' }}>Guest Journey</h1>
      <p style={{ color: '#666', marginBottom: '1.5rem' }}>
        The Guest Journey map is being prepared for the reunion weekend. Check back soon!
      </p>
      <a
        href="/guest-journey.html"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: '#1a6b3c', textDecoration: 'underline' }}
      >
        Open Guest Journey Map (standalone)
      </a>
    </div>
  );
}
